@use 'config' as config;
@use '~@cewe-designsystem-stylecomponents/mixins/breakpoints' as breakpoints;

@keyframes activeSlide {
  0% {
    opacity: 0;
  }

  95% {
    opacity: 1;
  }
}

@keyframes inactiveSlide {
  0% {
    opacity: 1;
  }

  99% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

:host {
  display: block;
  position: relative;
  overflow: hidden;

  /* Background wrapper for open content. Is expanded to full width of accordion and is visible through the closed tabs. */
  backgrounds {
    slot {
      display: block;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      transition: opacity 0s linear config.$animation-duration;
      animation: config.$animation-duration forwards inactiveSlide;
      opacity: 0;
      pointer-events: none;
    }

    slot.active {
      z-index: 2;

      animation: config.$animation-duration forwards activeSlide;
      opacity: 1;
    }

    ::slotted(*) {
      display: block;
      width: auto;
      height: 100%;
    }
  }

  slides {
    display: flex;
    position: relative;
    flex-direction: row;
    height: config.$accordion-gallery-v2-height;
    min-height: config.$accordion-gallery-v2-min-height;

    @include breakpoints.breakpoint(xs, only) {
      height: config.$accordion-gallery-v2-min-height;
    }

    @include breakpoints.breakpoint(sm, up) {
      height: config.$accordion-gallery-v2-large-height;
      min-height: config.$accordion-gallery-v2-min-large-height;
    }

    @include breakpoints.breakpoint('lg', 'up') {
      ::slotted(cwc-accordion-gallery-slide:not(:last-of-type)) {
        border-right: config.$accordion-gallery-tab-border-width solid config.$accordion-gallery-tab-border-color;
      }
    }

    /* Switch from horizontal accordion to vertical on mobile */
    @include breakpoints.breakpoint('lg', 'down') {
      flex-direction: column;

      ::slotted(cwc-accordion-gallery-slide:not(:first-of-type)) {
        border-top: config.$accordion-gallery-tab-border-width solid config.$accordion-gallery-tab-border-color;
      }
    }
  }
}
